<template>
    <div>
        <div class="pb-4 border-dotted border-b-2">
            <div class="text-tecis-blau text-xl font-bold">
                Das benötigte Anfangskapital
            </div>
            <div>{{ convert(getInitialCapital) }} €</div>
        </div>

        <div class="pb-4 pt-2 border-dotted border-b-2">
            <div class="text-tecis-blau text-xl font-bold">
                Einzahlungen gesamt
            </div>
            bei
            <span class="text-tecis-limette font-semibold">{{
                (R - A) * 12
            }}</span>
            Monaten
            <div>{{ convert(getInitialCapital) }} €</div>
        </div>

        <div class="pb-4 pt-2">
            <div class="text-tecis-blau text-xl font-bold">Zinsen gesamt</div>
            <div class="text-tecis-limette font-bold text-2xl">
                {{ convert(getInitialCapitalInterest) }} €
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    Name: 'InitialCapital',
    computed: {
        ...mapGetters(['getInitialCapital', 'getInitialCapitalInterest']),
        V: {
            get() {
                return this.$store.state.V;
            }
        },
        R: {
            get() {
                return this.$store.state.R;
            }
        },
        A: {
            get() {
                return this.$store.state.A;
            }
        },
        S: {
            get() {
                return this.$store.state.S;
            }
        }
    },
    methods: {
        convert(num) {
            return (Math.round(parseFloat(num) * 100) / 100).toLocaleString(
                'de-DE',
                {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                }
            );
        }
    }
};
</script>

<style></style>
